import React, {useEffect} from "react";
import PropTypes from 'prop-types';
import { jwtDecode } from 'jwt-decode'
import { Translate } from "../Translator";
import DatasourceBaseTextFields from "../Datasources/DatasourceBaseTextFields.jsx";

const DatasourceVoze = (props) => {

    useEffect(() => {
        const DecodedToken = jwtDecode(props.SecurityToken)
        props.IntegrationSettings.DatasourceSettings.TenantGuid = DecodedToken.TenantGuid
    }, []); 

    const Fields = [
        {Identifier:"InstanceDomain", Translation:Translate("Domain"), Required:true}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)

}

DatasourceVoze.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceVoze